<script setup lang="ts">
import type { ChipProps } from './UICarouselChips.props'

const props = defineProps<ChipProps>()

const emit = defineEmits(['select'])

const amendedBorder = computed(() => {
  switch (props.chip.boxColor) {
    case '#000000':
      return '1px solid #FFFFFF'
    case '#FFFFFF':
      return '1px solid #000000'
    default:
      return undefined
  }
})
</script>

<template>
  <button
    v-bind="$attrs"
    class="text-light-7 text-text-primary flex items-center gap-2.5"
    :class="
      chipSelected ? 'underline-effect-default' : 'underline-effect-appear'
    "
    @click="emit('select')"
  >
    <div
      v-if="chip.boxColor"
      class="h-8 w-8 shrink-0"
      :style="{
        backgroundColor: chip.boxColor,
        border: amendedBorder,
      }"
      :class="{ 'border-stroke-primary border': chipSelected }"
    />

    <p
      class="text-light-7 text-effect text-text-primary gap-xxs flex whitespace-nowrap pb-1"
    >
      {{ chip.label }}
      <span>({{ count }})</span>
    </p>
  </button>
</template>
